import React from 'react'
import styled from 'styled-components'
import { Color, Responsive, Size } from 'const'
import { ReactComponent as LensIcon } from 'assets/svg/lens.svg'
import { MEDIA_QUERY } from 'config/constants'
import ClViewer from '../ClViewer'
import { isBeforeOrEqualMock } from 'utils/helpers/function'
import _ from 'lodash'

const Lens = ({ content_r, content_l, isSameSalesDate = true }) => {
  if ((!content_l?.brand || !content_l?.name) && (!content_r?.brand || !content_r?.name)) return null

  const isLensLBeforeOrEqual31thMarch2025 = isBeforeOrEqualMock(content_l?.dev_sales_date, '2025-03-31')
  const isLensRBeforeOrEqual31thMarch2025 = isBeforeOrEqualMock(content_r?.dev_sales_date, '2025-03-31')

  return (
    <StyledLens>
      <div className="item_header">
        <LensIcon />
        <div className="item_type">レンズ</div>
      </div>
      <div className="row">
        <div className="label"></div>
        <div className="content_l">L</div>
        <div className="content_r">R</div>
      </div>
      <div className="row">
        <div className="label">レンズ名</div>
        <div className="content_l product_name">
          {`${content_l?.brand} \n`}
          <span
            className={
              content_l?.name?.indexOf(' ') >= 0 || content_l?.name?.indexOf('　') >= 0 ? 'break-word' : 'break-all'
            }
          >
            {content_l?.name}
          </span>
        </div>
        <div className="content_r product_name">
          {`${content_r?.brand} \n`}
          <span
            className={
              content_r?.name?.indexOf(' ') >= 0 || content_r?.name?.indexOf('　') >= 0 ? 'break-word' : 'break-all'
            }
          >
            {content_r?.name}
          </span>
        </div>
      </div>
      <div className="row">
        <div className="label">焦点区分</div>
        <div className="content_l">{content_l?.focus ? content_l?.focus.replace(/^[0-9]{3}:/g, '') : 'ー'}</div>
        <div className="content_r">{content_r?.focus ? content_r?.focus.replace(/^[0-9]{3}:/g, '') : 'ー'}</div>
      </div>
      <div className="row">
        <div className="label">度数</div>
      </div>
      <div className="row align_right">
        <div className="label">Sph</div>
        <div className="content_l">
          {content_l?.sph?.toString() ? (content_l?.sph >= 0 ? '+' : '') + parseFloat(content_l?.sph).toFixed(2) : 'ー'}
        </div>
        <div className="content_r">
          {content_r?.sph?.toString() ? (content_r?.sph >= 0 ? '+' : '') + parseFloat(content_r?.sph).toFixed(2) : 'ー'}
        </div>
      </div>
      <div className="row align_right">
        <div className="label">CYL</div>
        <div className="content_l">
          {content_l?.cyl?.toString() ? (content_l?.cyl >= 0 ? '+' : '') + parseFloat(content_l?.cyl).toFixed(2) : 'ー'}
        </div>
        <div className="content_r">
          {content_r?.cyl?.toString() ? (content_r?.cyl >= 0 ? '+' : '') + parseFloat(content_r?.cyl).toFixed(2) : 'ー'}
        </div>
      </div>
      <div className="row align_right">
        <div className="label">AX</div>
        <div className="content_l">{content_l?.ax || 'ー'}</div>
        <div className="content_r">{content_r?.ax || 'ー'}</div>
      </div>
      <div className="row align_right">
        <div className="label">ADD</div>
        <div className="content_l">{content_l?.add?.toString() ? parseFloat(content_l?.add).toFixed(2) : 'ー'}</div>
        <div className="content_r">{content_r?.add?.toString() ? parseFloat(content_r?.add).toFixed(2) : 'ー'}</div>
      </div>
      <div className="row align_right">
        <div className="label">PD</div>
        <div className="content_l">{content_l?.pd?.toString() ? parseFloat(content_l?.pd).toFixed(2) : 'ー'}</div>
        <div className="content_r">{content_r?.pd?.toString() ? parseFloat(content_r?.pd).toFixed(2) : 'ー'}</div>
      </div>
      <div className="row">
        <div className="label">素材</div>
        <div className="content_l">{content_l?.material ? content_l?.material.replace(/^[0-9]{3}:/g, '') : 'ー'}</div>
        <div className="content_r">{content_r?.material ? content_r?.material.replace(/^[0-9]{3}:/g, '') : 'ー'}</div>
      </div>
      <div className="row">
        <div className="label">設計</div>
        <div className="content_l">{content_l?.design ? content_l?.design.replace(/^[0-9]{3}:/g, '') : 'ー'}</div>
        <div className="content_r">{content_r?.design ? content_r?.design.replace(/^[0-9]{3}:/g, '') : 'ー'}</div>
      </div>
      <div className="row">
        <div className="label">機能</div>
        <div className="content_l">{content_l?.feature ? content_l?.feature.replace(/^[0-9]{3}:/g, '') : 'ー'}</div>
        <div className="content_r">{content_r?.feature ? content_r?.feature.replace(/^[0-9]{3}:/g, '') : 'ー'}</div>
      </div>
      <div className="row">
        <div className="label">カラー</div>
        <div className="content_l">{content_l?.lens_color || 'ー'}</div>
        <div className="content_r">{content_r?.lens_color || 'ー'}</div>
      </div>
      {!isSameSalesDate && (
        <div className="row warranry-wrapper">
          <div className="label" />
          <div className="content_l">
            {!_.isEmpty(content_l) && (
              <ClViewer isContactLens={false} isBeforeOrEqual31thMarch2025={isLensLBeforeOrEqual31thMarch2025} />
            )}
          </div>
          <div className="content_r">
            {!_.isEmpty(content_r) && (
              <ClViewer isContactLens={false} isBeforeOrEqual31thMarch2025={isLensRBeforeOrEqual31thMarch2025} />
            )}
          </div>
        </div>
      )}
    </StyledLens>
  )
}

const StyledLens = styled.div`
  > .item_header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 30px 0;

    > .item_type {
      font-size: ${Size.FONT.LG};
      margin: 4px 0;
      font-weight: 500;
    }
  }
  > .row {
    display: flex;
    margin-bottom: 15px;
    &.align_right {
      text-align: right;
      .label {
        font-weight: 500 !important;
      }
    }
    > .label {
      min-width: 84px;
      margin-right: 24px;
      ${MEDIA_QUERY.SP} {
        width: 52px;
      }
      font-weight: 700;
      font-size: ${Size.FONT.BIG};
    }
    > .gray {
      color: ${Color.FONT.GREY};
    }
    > .content_l {
      width: 100%;
      text-align: center;
      font-size: ${Size.FONT.BIGGER};
      font-weight: 500;

      @media screen and (max-width: ${Responsive.XS.DOWN}px) {
        font-size: ${Size.FONT.NORMAL};
      }

      &.product_name {
        @media screen and (max-width: ${Responsive.SM.DOWN}px) {
          white-space: pre-line;

          .break-word {
            word-break: break-word;
          }

          .break-all {
            word-break: break-all;
          }
        }
      }
    }
    > .content_r {
      width: 100%;
      text-align: center;
      font-size: ${Size.FONT.BIGGER};
      font-weight: 500;
      margin-left: 8px;

      @media screen and (max-width: ${Responsive.XS.DOWN}px) {
        font-size: ${Size.FONT.NORMAL};
      }
      > .hidden {
        visibility: hidden;
      }

      &.product_name {
        @media screen and (max-width: ${Responsive.SM.DOWN}px) {
          white-space: pre-line;

          .break-word {
            word-break: break-word;
          }

          .break-all {
            word-break: break-all;
          }
        }
      }
    }

    &.warranry-wrapper {
      .content_r {
        margin-left: 8px;
      }

      .label {
        @media screen and (max-width: ${Responsive.MD.DOWN}px) {
          display: none;
        }
      }
    }
  }
`

export default Lens
